var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormsColoerd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0662B9;}\r\n\t.st1{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,2.9H2.9c-1.2,0-2.1,1-2.1,2.2l0,13c0,1.2,1,2.2,2.2,2.2h17.3c1.2,0,2.2-1,2.2-2.2V7.2c0-1.2-1-2.2-2.2-2.2 h-8.6L9.3,2.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-12.5-12.5h48v48h-48V-12.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsColoerd);
export default __webpack_public_path__ + "static/media/forms_coloerd.f18e71f43e32d9f837b8bef8428a7f56.svg";
export { ForwardRef as ReactComponent };